<video
  width="100%"
  height="100%"
  #remoteVideo
  muted
  playsInline
  autoplay
  [controls]="false"
></video>
